import { getChromeRuntime } from './wrappers';
import { ProcessUrlResponse } from '../types';
import { getDownloadUrl } from '../constants';

export const getBlockedByQuotaScreenUrl = () =>
  getChromeRuntime().getURL('blocker.html#/quota-exceeded');

export const getBlockedByCategoryUrl = () => getPageBlockedUrl();

const getPageBlockedUrl = () =>
  getChromeRuntime().getURL('blocker.html#/page-not-allowed');

export const getScheduleRestrictedScreenUrl = () =>
  getChromeRuntime().getURL('blocker.html#/time-restricted');

export const getBlockedScreenUrl = (result: ProcessUrlResponse) => {
  switch (result) {
    case ProcessUrlResponse.BLOCK:
      return getBlockedByCategoryUrl();
    case ProcessUrlResponse.BLOCK_BY_QUOTA:
      return getBlockedByQuotaScreenUrl();
    case ProcessUrlResponse.BLOCK_BY_SCHEDULE:
      return getScheduleRestrictedScreenUrl();
    case ProcessUrlResponse.ALLOW:
      return undefined;
  }
};
export const matchesAuthorizationUrl = (url: string) =>
  url.indexOf(getDownloadUrl()) !== -1;

export const getOnboardingUrl = () =>
  getChromeRuntime().getURL('onboarding.html');

export const getSetupCompleteUrl = () =>
  getChromeRuntime().getURL('onboarding.html#/setup-complete');
